export const EXECUTIVE_DASHBOARD_CONFIG = {
    requests: {
        getExecutiveSummary: {
            url: 'dashboard/back/executive-summary'
        },
        getExecutiveReadyToSell: {
            url: 'dashboard/back/executive-ready-to-sell'
        },
        getExecutiveSales: {
            url: 'dashboard/back/executive-sales'
        },
    }
}
